import Controller from "./liveEtaConfiguration.controller";
import template from "./liveEtaConfiguration.html";

const liveEtaConfiguration = {
  template,
  controller: Controller,
  bindings: {
    cityId: "<",
    stationLatencyThreshold: "<",
    stationLatencyNotificationThreshold: "<",
  },
};

export default liveEtaConfiguration;



// WEBPACK FOOTER //
// ./src/components/liveEtaConfiguration/liveEtaConfiguration.component.js